<template>
  <v-overlay :value="value">
    <v-progress-circular
      indeterminate
      size="64"
      color="primary"
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  name: "LoadingOverlay",
  props: {
    value: {
      default: false
    }
  }
};
</script>

<style scoped lang="sass"></style>
